<template>
    <div class="container">
        <app-jeux-filtre :filtre="filtre" @search="search" @reset="reset"></app-jeux-filtre>
        <app-jeux-liste :liste="listeJeux" :nbJeux="nbJeux" @next="next" @select="select"></app-jeux-liste>
        <transition name="fade">
            <app-jeux-details :idJeu="jeuSelect" v-if="jeuSelect != 0" @fermer="jeuSelect = 0"></app-jeux-details>
        </transition>
    </div>
</template>

<script>
import jeuxFiltre from './components/jeuxfiltre.vue'
import jeuxListe from './components/jeuxliste.vue'
import jeuxDetails from './components/jeuxdetails.vue'

export default {
    name: 'app',
    components: {
        appJeuxFiltre: jeuxFiltre,
        appJeuxListe: jeuxListe,
        appJeuxDetails: jeuxDetails
    },
    data() {
        return {
            filtre: {
                nom: "",
                age: 0,
                joueurs: 0,
                duree: 0,
                type: "",
                categorie: "",
                dispo: ""
            },
            resultPage: 0,
            nbJeux: "0",
            listeJeux: [],
            jeuSelect: 0,
            resource: {}
        }
    },
    methods: {
        search() {
            this.nbJeux = "0";
            this.listeJeux = [];
            this.searchFrom(0)
        },
        reset() {
            this.filtre = this.$options.data().filtre
            this.resultPage = 0
            this.nbJeux = "0"
            this.listeJeux = []
            this.jeuSelect = 0
        },
        searchFrom(page=0) {
            let body = {
                nom: this.filtre.nom,
                age: this.filtre.age,
                joueurs: this.filtre.joueurs,
                duree: this.filtre.duree,
                emplacement: this.filtre.categorie,
                classification: this.filtre.type,
                dispo: this.filtre.dispo,
                page: page
            };
            this.resource.search({}, body)
                .then(res => {
                    return res.json();
                })
                .then(res => {
                    if (page == 0) {
                        this.nbJeux = res.Response.Total
                        this.listeJeux = res.Data
                    } else {
                        this.listeJeux = this.listeJeux.concat(res.Data)
                    }
                });
        },
        next() {
            this.resultPage++;
            this.searchFrom(this.resultPage++);
        },
        select(id) {
            this.jeuSelect = id;
        }
    },
    created() {
        let customActions = {
            search: {
                method: 'POST',
                url: 'jeu/recherche'
            }
        }
        this.resource = this.$resource('', {}, customActions, {emulateJSON: false});
    }
}
</script>

<style>
.fade-enter {
    opacity: 0;
}
.fade-enter-active {
    transition: opacity 0.2s;
}
.fade-leave {
    /* opacity: 1; */
}
.fade-leave-active {
    transition: opacity 0.2s;
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue